import { useFetcher } from 'react-router';
import React from 'react';
import type { Locality } from '@modules/ecommerce/type/locality';
import type { loader } from '~/routes/remix-api.ecommerce.search-localities';

const useLocalities = () => {
    const [results, setResults] = React.useState<Locality[]>([]);

    const fetcher = useFetcher<typeof loader>();

    const search = (query: string) => {
        fetcher.submit(
            {
                query,
            },
            { method: 'get', action: '/remix-api/ecommerce/search-localities' },
        );
    };

    const data = fetcher.data;

    React.useEffect(() => {
        setResults(data?.Localities?.nodes || []);
    }, [data]);

    return {
        results,
        loading: fetcher.state !== 'idle',
        search,
    };
};

export default useLocalities;
